import axios from 'axios';

// Endpoints do iam (`/iam/api/*`) vivem fora do prefixo `/api/v1` que
// `client.js` usa como baseURL — client dedicado, mesmo interceptor de
// Bearer, só apontando pra raiz diferente.
const BASE = import.meta.env.VITE_IAM_API_URL ?? '/iam';

const iamClient = axios.create({ baseURL: BASE, timeout: 15_000 });

iamClient.interceptors.request.use((config) => {
  try {
    const raw = localStorage.getItem('iex_tokens');
    const tokens = raw ? JSON.parse(raw) : null;
    if (tokens?.access) {
      config.headers.Authorization = `Bearer ${tokens.access}`;
    }
  } catch {
    // localStorage inacessível (SSR ou private mode)
  }
  return config;
});

export default iamClient;
